@if (promotionsService.hasCartPromotions()) {
<button
  type="button"
  class="btn btn-outline-primary w-100 promotions-btn"
  [class.promotions-btn--compact]="compact()"
  (click)="openModal()"
>
  <span class="material-symbols-outlined promotions-btn__icon">sell</span>
  <span class="promotions-btn__label">See Available Promotions</span>
  @if (promotionsService.appliedPromotions().length) {
  <span class="badge bg-primary rounded-pill promotions-btn__badge">{{ promotionsService.appliedPromotions().length }}</span>
  }
</button>
}
